const AboutWhyChoose = ({ data }) => (
  <section className="py-32 bg-white">
    <div className="max-w-5xl mx-auto px-6 text-center">
      <h2 className="text-5xl font-bold text-[#0a363c] mb-10">{data.title}</h2>
      <ul className="space-y-6 text-lg text-[#0a363c]/80 mx-auto max-w-2xl">
        {data.points.map((point, idx) => (
          <li key={idx} className="flex items-center gap-4 justify-center">
            <span className="text-[#e2bf9c] text-3xl">✔</span>
            <span>{point}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default AboutWhyChoose;
